module.exports = __webpack_public_path__ + "static/media/pic_wushuju.186d3c2f.png";